/**
=========================================================
* Arakan - v2.1.0
=========================================================

* Product Page: https://www.trakib.com/product/material-dashboard-pro-react
* Copyright 2022 Trakib (https://www.trakib.com)

Coded by www.trakib.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// @material-ui core components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Arakan components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";

// Settings page components
import FormField from "components/FormField";

import crudsService from "services/cruds-service";
import { Autocomplete, Chip, Switch, TextField } from "@mui/material";
import MDInput from "components/MDInput";
import i18n from "i18n";

function MainInfo({
  changeHandler,
  autoSwitchChangeHandler,
  info,
  setErrors,
  errors,
  notification,
  setNotification,
  tags,
  project,
  setProject,
}) {
  const { t } = i18n;

  return (
    <>
      <Card id="basic-info" sx={{ overflow: "visible" }}>
        <MDBox p={3}>
          <MDTypography variant="h5">بيانات النشر</MDTypography>
        </MDBox>
        <MDBox pb={3} px={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                <MDBox mt={0.5}>
                  <Switch
                    name="status"
                    checked={info.status === "published" ? true : false}
                    onChange={() =>
                      autoSwitchChangeHandler(
                        "status",
                        info.status === "published" ? "draft" : "published"
                      )
                    }
                  />
                </MDBox>
                <MDBox width="80%" ml={0.5}>
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    الحالة
                  </MDTypography>
                </MDBox>
              </MDBox>
            </Grid>
            <Grid item xs={12} lg={12}>
              <FormField
                variant="outlined"
                type="number"
                label="الترتيب"
                name="sequence"
                value={info.sequence}
                onChange={changeHandler}
                placeholder={"sequence"}
                error={errors.sequence}
              />
            </Grid>
            <Grid item xs={12} lg={12}>
              <Autocomplete
                multiple
                options={tags}
                name="tags"
                value={info.tags || []}
                onChange={async (event, v, reason, detail) => {
                  if (project.id) {
                    if (reason === "removeOption") {
                      const removedItem = project?.tags.find(
                        (orgItem) => orgItem?.id === detail.option?.id
                      );
                      let arr = project.tags.filter(
                        (tag) => tag?.id !== detail.option?.id
                      );
                      setProject({ ...project, tags: arr });
                      await crudsService.removeItemWithFilter(
                        `items/faq_tags`,
                        {
                          query: {
                            filter: {
                              tags_id: { _eq: removedItem?.id },
                              faq_id: { _eq: project?.id },
                            },
                          },
                        }
                      );
                    } else if (reason === "selectOption") {
                      let arr = project.tags;
                      arr.push(detail.option);
                      setProject({ ...project, tags: arr });
                      await crudsService.createItem(`items/faq_tags`, {
                        tags_id: detail.option?.id,
                        faq_id: project?.id,
                      });
                    }
                  }
                  autoSwitchChangeHandler("tags", v);
                }}
                renderOption={(props, option) => {
                  const { key, ...rest } = props;
                  return (
                    <li key={key} {...rest}>
                      {option.data ? option.data.name : option.name}
                    </li>
                  );
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => {
                    const { key, ...tagProps } = getTagProps({ index });
                    return (
                      <Chip
                        key={option.id || key}
                        {...tagProps}
                        label={option.data?.name || option.name}
                      />
                    );
                  })
                }
                getOptionLabel={(option) =>
                  option?.data?.name || option?.name || ""
                }
                isOptionEqualToValue={(option, item) => option?.id === item?.id}
                renderInput={(params) => (
                  <MDInput
                    {...params}
                    variant="outlined"
                    label="الوسوم"
                    error={errors.tags}
                  />
                )}
              />
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    </>
  );
}

export default MainInfo;
